export const AchFeeTemplateFields = {
	IsDefault: {
		name: "is_default",
		displayName: "Default Fee Template",
	},
	Status: {
		name: "is_active",
		displayName: "Status",
	},
	TemplateName: {
		name: "name",
		displayName: "Template Name",
	},
	SetupFee: {
		name: "setup_fee",
		displayName: "Setup Fee",
	},
	MonthlyFee: {
		name: "monthly_fee",
		displayName: "Monthly Fee",
	},
	TransactionFee: {
		name: "transaction_fee",
		displayName: "Transaction Fee",
	},
	OriginationDiscountFee: {
		name: "origination_discount_fee",
		displayName: "Origination Discount Fee",
	},
	OriginationLargeTransactionDiscountFee: {
		name: "origination_large_transaction_discount_fee",
		displayName: "Origination Large Transaction Discount Fee",
	},
	StandardReturnFee: {
		name: "standard_return_fee",
		displayName: "Standard Return Fee",
	},
	NoticeOfChangeReturnFee: {
		name: "notice_of_change_return_fee",
		displayName: "Notice Of Change Return Fee",
	},
	ChargebackReturnFee: {
		name: "chargeback_return_fee",
		displayName: "Chargeback Return Fee",
	},
	AccountVerificationFee: {
		name: "account_verification_fee",
		displayName: "Account Verification Fee",
	},
	AccountVerificationPlusFee: {
		name: "account_verification_plus_fee",
		displayName: "Account Verification Plus Fee",
	},
};
